import React, { useState } from 'react';
import { graphql, Link } from 'gatsby';
import { SmartLink } from 'components/smart-link';
import Logo from 'assets/icons/black-logo.svg';
import { SocialMediaEnum } from 'utils/enums';
import * as styles from './footer.module.scss';
import { SocialMedia } from '../social-media/social-media';

type LinkType = {
  name: string,
  link: string,
};
type BannerInfo ={
  nameButton:string
  linkToSubscribe:string
}

type StrapiFooter = {
  data: {
    strapiFooter: {
      brandSubtitle: string
      links: LinkType[]
      socialMedia: {
        facebook: string
        instagram: string
        tiktok: string
        youtube: string
      }
      medicalDisclaimerTitle: string
      medicalDisclaimerDescription: string
    }
    strapiSubscribeBannerInfo:BannerInfo
  }
};

const Footer = ({ data }: StrapiFooter) => {
  const {
    brandSubtitle, links, socialMedia, medicalDisclaimerTitle, medicalDisclaimerDescription,
  } = data.strapiFooter;
  const { nameButton, linkToSubscribe } = data.strapiSubscribeBannerInfo;
  return (
    <div className={styles.footer}>
      <div className={styles.genericContainer} style={{ position: 'relative' }}>
        <nav className={styles.gridFooterContainer}>
          <div className={styles.brandContainer}>
            <Link aria-label="Home page" to="/"><Logo /></Link>
            <span className={styles.brandSubtitle}>{brandSubtitle}</span>
          </div>
          <div className={styles.linksContainer}>
            {links.map((link: LinkType) => (
              <SmartLink
                key={link.name}
                ariaLabel={link.name}
                to={link.link}
                className={styles.linkStyle}
              >
                {link.name}
              </SmartLink>
            ))}
          </div>
          <div className={styles.subscribeContainer}>
            <p className={styles.footerSubtitle}>
              Subscribe for dental tips
            </p>
            <SmartLink
              key={nameButton}
              ariaLabel={nameButton}
              to={linkToSubscribe}
              className={styles.buttonStyle}
            >
              {nameButton}
            </SmartLink>
            <div className={styles.socialMedia}>
              <SocialMedia type={SocialMediaEnum.Facebook} link={socialMedia.facebook} />
              <SocialMedia type={SocialMediaEnum.Instagram} link={socialMedia.instagram} />
              <SocialMedia type={SocialMediaEnum.YouTube} link={socialMedia.youtube} />
              <SocialMedia type={SocialMediaEnum.TikTok} link={socialMedia.tiktok} />
            </div>
          </div>
          <div>
            <p className={styles.footerSubtitle}>
              {medicalDisclaimerTitle}
            </p>
            <p className={styles.disclaimerDescription}>
              {medicalDisclaimerDescription}
            </p>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Footer;

export const query = graphql`
  query {
    strapiFooter {
      brandSubtitle
      links {
        name
        link
      }
      socialMedia {
        facebook
        instagram
        tiktok
        youtube
      }
      medicalDisclaimerTitle
      medicalDisclaimerDescription
    }
    strapiSubscribeBannerInfo {
    nameButton
    linkToSubscribe
    }
  }
`;
